export default {
  technicianJobCreated: 'Technician Job created successfully.',
  technicianJobUpdated: 'Technician Job updated successfully.',
  login: 'Logged In successfully.',
  signup: 'Registered successfully.',
  buildingCreated: 'Building created successfully.',
  proposalCreated: 'Proposal created successfully.',
  selectedPrinter: 'Printer associated successfully.',
  printerAlreadyAssociated:
    'Selected printer is already associated with the client.',
  updatePersonalInformation: 'Username updated successfully.',
  updateContactInformation: 'Contact updated successfully.',
  updateCompanyInformation: 'Company name updated successfully.',
  proposalAccepted: 'Proposal has been accepted.',
  proposalDeclined: 'Proposal has been declined.',
  contractCreated: 'Contract has been created.',
  contractAccepted: 'Contract accepted.',
  contractRejected: 'Contract rejected.',
};
